import { useEffect, useMemo } from "react";
import { colors, updateThemeColors } from "@tecsinapse/cortex-core";
//#region src/modules/core/hooks/useTheme.ts
var themes = {
	abraland: { primary: {
		xlight: "#f0fdf4",
		light: "#83d69b",
		medium: "#0B6836",
		dark: "#064a26",
		xdark: "#032a15"
	} },
	bajaj: { primary: {
		xlight: "#f0f6ff",
		light: "#83b3fc",
		medium: "#004da8",
		dark: "#003576",
		xdark: "#001e42"
	} },
	carrera: { primary: {
		xlight: "#fffbf0c",
		light: "#f5d983",
		medium: "#c7970d",
		dark: "#8d6a09",
		xdark: "#503c05"
	} },
	hdb: { primary: {
		xlight: "#fff6f0",
		light: "#fcb583",
		medium: "#f48322",
		dark: "#f53f1f",
		xdark: "#8b1f0f"
	} },
	partform: { primary: {
		xlight: "#CDFAFE",
		light: "#00D4FF",
		medium: "#3DA3BF",
		dark: "#155E75",
		xdark: "#0C4A6E"
	} },
	portalnissan: { primary: {
		xlight: "#fff0f2",
		light: "#fc8399",
		medium: "#c3002f",
		dark: "#8b0021",
		xdark: "#4f0012"
	} },
	royalenfield: { primary: {
		xlight: "#fef2f2",
		light: "#fca5a5",
		medium: "#da291c",
		dark: "#991d14",
		xdark: "#55100b"
	} },
	triumph: { primary: {
		xlight: "#fef2f2",
		light: "#fca5a5",
		medium: "#b91c1c",
		dark: "#f53f1f",
		xdark: "#450a0a"
	} },
	voge: { primary: {
		xlight: "#FFFCD8",
		light: "#FDE06E",
		medium: "#E8BA00",
		dark: "#D69A2E",
		xdark: "#8F5D1A"
	} },
	tecsinapse: { primary: colors.primary }
};
var useTheme = (_realm, shadowRoot) => {
	const realm = useMemo(() => _realm ? _realm.toLowerCase() : null, [_realm]);
	useEffect(() => {
		if (realm && realm in themes) updateThemeColors({
			theme: themes[realm],
			shadowRoot
		});
	}, [realm, shadowRoot]);
	return realm && realm in themes ? themes[realm] : themes.tecsinapse;
};
//#endregion
export { themes, useTheme };
